var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.924 1 1 5.924 1 12s4.924 11 11 11 11-4.924 11-11S18.076 1 12 1zm3.711 13.155a1.1 1.1 0 1 1-1.555 1.556L12 13.555l-2.156 2.156a1.1 1.1 0 1 1-1.555-1.556L10.445 12 8.289 9.844A1.1 1.1 0 1 1 9.844 8.29L12 10.445l2.156-2.156a1.1 1.1 0 1 1 1.555 1.555L13.555 12l2.156 2.155z",
    fill: "#586179"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircle);
export default __webpack_public_path__ + "static/media/icon-close-circle.5098eead.svg";
export { ForwardRef as ReactComponent };